import Select from './Select';
import Option from './Option';
import './style.css';
const CustomSelect = {Select, Option};
export default CustomSelect;
